const flattenFeatureFlags = (configArray = []) => {
  if (!Array.isArray(configArray)) return [];

  return configArray
    .filter((item) => item.key.startsWith('featureFlags.'))
    .map(({ key, value, kind }) => {
      const cleanKey = key.replace(/^featureFlags\./, '');
      const keyParts = cleanKey.split('.');

      return {
        key: cleanKey,
        group: keyParts[0],
        name: keyParts.slice(1).join('.'),
        type: kind,
        value: kind === 'boolean' ? value === 'true' : value
      };
    });
};

export default flattenFeatureFlags;
